import {
  ODataHeader,
  ODataString,
  ODataDecimal,
  ODataBoolean,
  // ODataCustom,
  // ODataStringContains,
  // ODataStringEndsWith,
  // ODataStringEquals,
  // ODataStringNotContains,
  // ODataStringNotEquals,
  // ODataStringStartsWith,
} from "pbas-vue-components";

import { translate } from "../trans";
import store from "@/store";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

function getFeesHeaders(provinces) {
  return [
    new ODataHeader({
      type: new ODataString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "globals.province",
      type: new ODataString("FeeGuide/ProvinceId", {
        getString: (item) => {
          const lang = store.getters['common/language']
          return translate(provinces.filter(o=>o.Id===item.FeeGuide.ProvinceId)[0], lang.language);
        },
      }),
      sortable: true,
      visible: true,
      searchable: false,
    }),
    // new ODataHeader({
    //   type: new ODataString("FeeGuide/Province/Name"),
    //   sortable: true,
    //   visible: false,
    //   allowVisibilityChange: false,
    // }),
    // new ODataHeader({
    //   type: new ODataString("FeeGuide/Province/Translations[]/LanguageCode"),
    //   visible: false,
    //   allowVisibilityChange: false,
    //   searchable: false,
    // }),
    // new ODataHeader({
    //   title: "globals.province",
    //   type: new ODataString("FeeGuide/Province/Translations[]/DisplayValue", {
    //     getString: item => {
    //       if (!item) return "";
    //       const lang = store.getters['common/language']
    //       return translate(item.FeeGuide.Province, lang.language);
    //     }
    //   }),
    //   visible: true,
    //   searchable: true,
    //   sortable: true,
    //   orderByKey: "FeeGuide/Province/Name",
    // }),
    new ODataHeader({
      title: "globals.name",
      type: new ODataString("Benefit/Name"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.category",
      type: new ODataString("Benefit/Category"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.employer_files.code",
      type: new ODataString("Code"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    // new ODataHeader({
    //   title: "globals.description",
    //   type: new ODataString("Description"),
    //   sortable: true,
    //   visible: true,
    //   searchable: true,
    // }),
    new ODataHeader({
      title: "headers.health_reasonable_customary_guides.fee_per_claim",
      type: new ODataBoolean("IndividualFee"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.health_reasonable_customary_guides.fee",
      type: new ODataDecimal("Fee", {
        getString: (item) => {
          const value = item.Fee;
          if (value === null || value === undefined) {
            return "";
          }
          if (typeof value !== "number") {
            return value;
          }
          return formatter.format(value);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.health_reasonable_customary_guides.lab_fee_per_claim",
      type: new ODataBoolean("IndividualLabFee"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.health_reasonable_customary_guides.lab_fee",
      type: new ODataDecimal("LabFee", {
        getString: (item) => {
          const value = item.LabFee;
          if (value === null || value === undefined) {
            return "";
          }
          if (typeof value !== "number") {
            return value;
          }
          return formatter.format(value);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
  ];
}
export default getFeesHeaders;
